

import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router  } from '@angular/router';
import saveAs from 'file-saver';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CommonStorageService } from 'src/app/shared/services/common-storage.service';
import { TamMain } from '../../../models/tam-main.model';
import { TrainingAndAssessmentMaterialsStorageService } from '../../../services/training-and-assessment-materials-storage.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import JSZip from 'jszip';
import { environment } from 'src/environments/environment';
import FileSaver from 'file-saver';
import { TamOccupation } from '../../../models/tam-occupation.model';


@Component({
  selector: 'app-cblm-generic-data',
  templateUrl: './cblm-generic-data.component.html',
  styleUrls: ['./cblm-generic-data.component.scss']
})
export class CblmGenericDataComponent implements OnInit {

  csList: any[] = [];
  occupationList: TamOccupation[] = [];
  occupationMap: Map<string, string> = new Map();

  tamMain: TamMain;
  tamMainId: number;
  csShow: boolean = false;
  cadShow: boolean = false;
  userInfo: any;
  showCreateButton: boolean = false;
  
  // Arrays for competency data
  genericCompetencies: any[] = [];
  specificCompetencies: any[] = [];
  occupationCompetencies: any[] = [];

  cblmListGeneric: any[] = [];
  cblmListSector: any[] = [];

  // Pagination variables for generic table (adjust as needed for others)
  total: number = 0;
  size: number = 10;
  page: number = 1;
  showingAction: boolean = false;

  imageURL: SafeResourceUrl | null = null;
  pdfUrl: SafeResourceUrl | null = null;
  isVisibleForAttachment = false;
  isImageLoading = true;
  imageTypeArray: string[] = ['jpg', 'jpeg', 'png'];
  varTamTypeSelectedId: number;
   countGeneric: number;
   countSector: number;

  constructor(
    private trainingAndAssessmentMaterialsStorageService: TrainingAndAssessmentMaterialsStorageService,
    private notification: NzNotificationService,
    private route: ActivatedRoute,
    private commonStorageService: CommonStorageService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    // Extract tamMainId from query parameters
    this.tamMainId = Number(this.route.snapshot.queryParamMap.get('tamMainId'));
    this.trainingAndAssessmentMaterialsStorageService
      .readTamMainById(this.tamMainId)
      .subscribe((res) => {
        this.tamMain = res.data;
         this.varTamTypeSelectedId =this.tamMain.tamType.id;
        // Convert date arrays into Date objects if necessary.
        if (
          this.tamMain.approvalDate &&
          Array.isArray(this.tamMain.approvalDate)
        ) {
          // Note: Month in JavaScript is 0-based.
          const [year, month, day, hour, minute] = this.tamMain.approvalDate;
          this.tamMain.approvalDate = new Date(
            year,
            month - 1,
            day,
            hour,
            minute
          );
        }
        if (
          this.tamMain.receivedDate &&
          Array.isArray(this.tamMain.receivedDate)
        ) {
          const [year, month, day, hour, minute] = this.tamMain.receivedDate;
          this.tamMain.receivedDate = new Date(
            year,
            month - 1,
            day,
            hour,
            minute
          );
        }
        this.additionalInformation(this.tamMain);
      });
  }

  ngOnInit(): void {
    this.tamMainId = Number(this.route.snapshot.queryParamMap.get('tamMainId'));
       if ( (this.tamMainId === null && this.tamMainId === '')) {
      this.router.navigate(
        ['home/training-and-assessment-materials/tam-list']
      );
    }
     this.trainingAndAssessmentMaterialsStorageService
      .readTamMainById(this.tamMainId)
      .subscribe((res) => {
        this.tamMain = res.data;
         this.varTamTypeSelectedId =this.tamMain.tamType.id;
          if (this.varTamTypeSelectedId === 4){
           this.trainingAndAssessmentMaterialsStorageService
                .readCblmDataByTamMainId(this.tamMainId)
                .subscribe({
                  next: (res: any) => {
                     this.cblmListGeneric = res.data.tamGeneric;
                     //alert(JSON.stringify(this.cblmListGeneric));
                     this.cblmListSector = res.data.tamSector;

                     if (res.data.tamSector == null){

                           this.countSector =0;
                     }else{

                       this.countSector = this.cblmListSector.length;
                     }

                     if (res.data.tamSector == null){

                           this.countGeneric =0;
                     }else{

                      this.countGeneric = this.cblmListGeneric.length;
                     }
                     //alert(JSON.stringify(this.cblmListSector));                     
                  },
                  error: () => {
                    //this.notification.error('Error', 'Failed to load CBLM data');
                  },
                });
          }// end if 


        // Convert date arrays into Date objects if necessary.
        if (
          this.tamMain.approvalDate &&
          Array.isArray(this.tamMain.approvalDate)
        ) {
          // Note: Month in JavaScript is 0-based.
          const [year, month, day, hour, minute] = this.tamMain.approvalDate;
          this.tamMain.approvalDate = new Date(
            year,
            month - 1,
            day,
            hour,
            minute
          );
        }
        if (
          this.tamMain.receivedDate &&
          Array.isArray(this.tamMain.receivedDate)
        ) {
          const [year, month, day, hour, minute] = this.tamMain.receivedDate;
          this.tamMain.receivedDate = new Date(
            year,
            month - 1,
            day,
            hour,
            minute
          );
        }
        this.additionalInformation(this.tamMain);
      });
    this.userId();
    this.getOccupationList();
  }

  getOccupationList() {
    this.trainingAndAssessmentMaterialsStorageService
      .getOccupationList()
      .subscribe({
        next: (res: any) => {
          const list = Array.isArray(res) ? res : res.data;

          if (!list) {
            console.error('Occupation list is empty or invalid:', res);
            return;
          }

          this.occupationList = list;

          this.occupationMap = new Map<string, string>(
            this.occupationList.map((o: any) => [String(o.id), o.name])
          );

          this.loadTamData();
        },
        error: () => {
          this.notification.error('Error', 'Failed to load occupation list');
        },
      });
  }

  userId(): void {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
  }

  loadTamData(): void {
    this.trainingAndAssessmentMaterialsStorageService
      .getTamDetailWithCBLM(this.tamMainId)
      .subscribe({
        next: (res: any) => {
          // Assuming the API returns keys: genericCompetencies, specificCompetencies, occupationCompetencies
          this.genericCompetencies = res.genericCompetencies || [];
          this.specificCompetencies = res.specificCompetencies || [];
          this.occupationCompetencies = res.occupationCompetencies.map((item: any) => ({
            ...item,
            occupationName:
              this.occupationMap.get(String(item.occupation)) ??
              item.occupation,
          }));
          // For pagination example (generic competency table)
          this.total = this.genericCompetencies.length;
        },
        error: () => {
          this.notification.error('Error', 'Failed to load competency data');
        },
      });
  }

  additionalInformation(tamMain: TamMain): void {
    if (tamMain.tamType && tamMain.tamType.shortName.toUpperCase() === 'CS') {
      this.csShow = true;
    } else if (
      tamMain.tamType &&
      tamMain.tamType.shortName.toUpperCase() === 'CAD'
    ) {
      this.cadShow = true;
    }
  }

  onDownload(data: TamMain): void {
    this.commonStorageService.downloadFile(data.docFilePath).subscribe({
      next: (result: any) => {
        let fileName = data.tamApplicationId;
        const contentDisposition = result.headers.get('Content-Disposition');
        if (contentDisposition) {
          const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = fileNameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            const totalFileName = matches[1].replace(/['"]/g, '');
            const fullFile = totalFileName.split('.');
            const exten = fullFile[1];
            fileName = fileName + '.' + exten;
          }
        }
        saveAs(result.body, fileName);
      },
      error: (error: any) =>
        this.notification.error('Failed!', 'No file found!'),
    });
  }

  // Example methods for edit and delete in generic competency table.
  extraGenericTemplate: string | TemplateRef<void> | undefined;

  onEdit(id: number): void {
    console.log('Edit competency with id:', id);
  }

  onDelete(id: number): void {
    console.log('Delete competency with id:', id);
  }

  /**
   * Downloads all attachments for a given competency row as a ZIP file.
   */
  onDownloadAttachments(row: any): void {
    if (row.attachments && row.attachments.length > 0) {
      const zip = new JSZip();
      const zipFileName = row.unitCode
        ? `${row.unitCode}_attachments.zip`
        : `${row.id}_attachments.zip`;
      const filePromises = row.attachments.map((attachment: any) => {
        const fileUrl =
          environment.fileServiceApiUrl + attachment.attachmentUrl;
        return fetch(fileUrl).then((response) => {
          if (response.ok) {
            return response.blob().then((blob) => {
              zip.file(attachment.attachmentTitle, blob);
            });
          } else {
            throw new Error(
              'Failed to fetch file: ' + attachment.attachmentUrl
            );
          }
        });
      });
      Promise.all(filePromises)
        .then(() => zip.generateAsync({ type: 'blob' }))
        .then((content) => {
          FileSaver.saveAs(content, zipFileName);
        })
        .catch((error) => {
          console.error('Error downloading attachments:', error);
          this.notification.error('Error', 'Failed to download attachments');
        });
    } else {
      this.notification.info('Info', 'No attachments available to download');
    }
  }

  /**
   * Fetches an attachment file and then shows its preview.
   */
  async setBase64AttachmentforPreview(attachment: any): Promise<void> {
    const fileUrl = attachment.attachmentUrl;
    try {
      const response = await fetch(environment.fileServiceApiUrl + fileUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch file: ' + fileUrl);
      }
      const blob = await response.blob();
      const fileUrlBase64 = URL.createObjectURL(blob);
      const fileType = this.getFileTypeFromPreviousAttachment(
        fileUrl,
        attachment
      );
      this.previewImage(fileType, fileUrlBase64, attachment);
    } catch (error) {
      console.error('Error fetching file for preview:', error);
      this.notification.error('Error', 'Failed to load attachment for preview');
    }
  }

  /**
   * Helper to determine file type from URL or file title.
   */
  getFileTypeFromPreviousAttachment(fileUrl: string, attachment?: any): string {
    let match = fileUrl.match(/\.([0-9a-z]+)(?:[\?#]|$)/i);
    let extension = match ? match[1].toLowerCase() : '';
    if (!extension && attachment && attachment.attachmentTitle) {
      match = attachment.attachmentTitle.match(/\.([0-9a-z]+)(?:[\?#]|$)/i);
      extension = match ? match[1].toLowerCase() : '';
    }
    if (this.imageTypeArray.includes(extension)) {
      return 'image';
    } else if (extension === 'pdf') {
      return 'pdf';
    } else if (extension) {
      return extension;
    }
    return 'other';
  }

  /**
   * Shows attachment preview: if image or PDF, opens a modal; otherwise, initiates download.
   */
  previewImage(
    fileType: string | undefined,
    fileUrl: any,
    attachment?: any
  ): void {
    // Reset previous preview values.
    this.imageURL = null;
    this.pdfUrl = null;
    this.isImageLoading = false;

    if (fileType === 'image' || fileType === 'pdf') {
      this.isVisibleForAttachment = true;
      if (fileType === 'image') {
        this.imageURL = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
      } else {
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
      }
    } else {
      const inferredExtension =
        fileType && fileType !== 'other' ? fileType : '';
      const fallbackFileName =
        attachment && attachment.attachmentTitle
          ? `${attachment.attachmentTitle}${
              inferredExtension ? '.' + inferredExtension : ''
            }`
          : 'downloaded_file' +
            (inferredExtension ? '.' + inferredExtension : '');
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', fileUrl);
      link.setAttribute('download', fallbackFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  /**
   * Closes the preview modal.
   */
  handleCancelFile(): void {
    this.isVisibleForAttachment = false;
    this.imageURL = null;
    this.pdfUrl = null;
  }

  /**
   * Utility to strip file extension for display purposes.
   */
  getCleanFileTitle(fileTitle: string): string {
    if (!fileTitle) return fileTitle;
    const dotIndex = fileTitle.lastIndexOf('.');
    return dotIndex > 0 ? fileTitle.substring(0, dotIndex) : fileTitle;
  }

    goToMain(): void{
    this.router.navigate(
      ['/home/training-and-assessment-materials/tam-list'],
      {
        queryParams: { tamMainId: this.tamMainId }
      }
    );
  }

}
